import type { AxiosError, AxiosRequestConfig } from 'axios'
import type { Perrito } from '../api/types'
import { useSuspenseQuery } from '@tanstack/react-query'
import { getPerritos } from '../api/perritos'
import { TAG_TYPES } from '../config'

interface UseListPerritosOptions {
  axiosConfig?: AxiosRequestConfig
}

export function useListPerritos(options: UseListPerritosOptions = {}) {
  const { axiosConfig } = options

  return useSuspenseQuery<Perrito[], AxiosError>({
    queryKey: [TAG_TYPES.PERRITOS],
    queryFn: async () => {
      return await getPerritos(axiosConfig)
    },
  })
}

export default useListPerritos
